import { CURRENCY_MAP } from '~core/constants/global.constants';

export function numberToWords(n: number): string {
  if (n === 0) return 'zéro';

  const units = [
    '',
    'un',
    'deux',
    'trois',
    'quatre',
    'cinq',
    'six',
    'sept',
    'huit',
    'neuf'
  ];
  const tens = [
    '',
    'dix',
    'vingt',
    'trente',
    'quarante',
    'cinquante',
    'soixante',
    'soixante-dix',
    'quatre-vingt',
    'quatre-vingt-dix'
  ];
  const teens = [
    'dix',
    'onze',
    'douze',
    'treize',
    'quatorze',
    'quinze',
    'seize',
    'dix-sept',
    'dix-huit',
    'dix-neuf'
  ];

  function convertGroup(n: number): string {
    let words = '';

    if (n >= 100) {
      const h = Math.floor(n / 100);
      if (h > 1) {
        words += units[h] + ' cent';
        if (n % 100 === 0) words += 's';
      } else {
        words += 'cent';
      }
      n %= 100;
      if (n > 0) words += ' ';
    }

    if (n >= 20) {
      const t = Math.floor(n / 10);
      const u = n % 10;

      if (t === 7) {
        words += 'soixante-' + (u === 1 ? 'et-onze' : teens[u]);
      } else if (t === 9) {
        words += 'quatre-vingt-' + teens[u];
      } else {
        words += tens[t];
        if (u === 1) words += '-et-un';
        else if (u > 1) words += '-' + units[u];
        // handle plural for 80
        if (t === 8 && u === 0) words += 's';
      }
    } else if (n >= 10) {
      words += teens[n - 10];
    } else if (n > 0) {
      words += units[n];
    }

    return words;
  }

  let words = '';
  const quadrillion = Math.floor(n / 1e15);
  n %= 1e15;
  const trillion = Math.floor(n / 1e12);
  n %= 1e12;
  const billion = Math.floor(n / 1e9);
  n %= 1e9;
  const million = Math.floor(n / 1e6);
  n %= 1e6;
  const thousand = Math.floor(n / 1e3);
  n %= 1e3;
  const remaining = Math.floor(n);

  if (quadrillion > 0)
    words +=
      convertGroup(quadrillion) +
      ' quadrillion' +
      (quadrillion > 1 ? 's' : '') +
      ' ';
  if (trillion > 0)
    words +=
      convertGroup(trillion) + ' trillion' + (trillion > 1 ? 's' : '') + ' ';
  if (billion > 0)
    words +=
      convertGroup(billion) + ' milliard' + (billion > 1 ? 's' : '') + ' ';
  if (million > 0)
    words +=
      convertGroup(million) + ' million' + (million > 1 ? 's' : '') + ' ';
  if (thousand > 0) {
    if (thousand === 1) words += 'mille ';
    else words += convertGroup(thousand) + ' mille ';
  }
  if (remaining > 0 || words === '') words += convertGroup(remaining);

  return words.trim().replace(/  +/g, ' ');
}

export function amountToWords(
  amount: number,
  currency: string = 'XOF'
): string {
  const roundedAmount = Math.floor(amount);
  const decimals = Math.round((amount - roundedAmount) * 100);

  const cur = currency.toUpperCase();
  const config = CURRENCY_MAP[cur];

  let result = numberToWords(roundedAmount);

  if (config) {
    // Partie entière
    result +=
      ' ' + (roundedAmount > 1 ? config.unitPlural : config.unitSingular);

    if (config.suffix) {
      result += ' ' + config.suffix;
    }

    // Partie décimale
    if (decimals > 0 && config.subUnitSingular && config.subUnitPlural) {
      result +=
        ' et ' +
        numberToWords(decimals) +
        ' ' +
        (decimals > 1 ? config.subUnitPlural : config.subUnitSingular);
    }
  } else {
    result += ' ' + cur;
  }

  return result.trim().replace(/  +/g, ' ');
}
